import * as types from '../actions/templateTypes';

const initialState = {
    isLibraryOpen: false,
    categories: [],
    allTemplates: [],
    selectedCategoryId: 'all',
    searchQuery: '',
    viewMode: 'grid', // 'grid' veya 'list'
    isLoading: false
};

const templateLibraryReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.OPEN_TEMPLATE_LIBRARY:
            return {
                ...state,
                isLibraryOpen: true
            };
            
        case types.CLOSE_TEMPLATE_LIBRARY:
            return {
                ...state,
                isLibraryOpen: false
            };
            
        case types.SELECT_CATEGORY:
            return {
                ...state,
                selectedCategoryId: action.payload
            };
            
        case types.SEARCH_TEMPLATES:
            return {
                ...state,
                searchQuery: action.payload
            };
            
        case types.CLEAR_SEARCH:
            return {
                ...state,
                searchQuery: '',
                selectedCategoryId: 'all'
            };
            
        case types.SET_VIEW_MODE:
            return {
                ...state,
                viewMode: action.payload
            };
            
        case types.LOAD_TEMPLATES_SUCCESS:
            return {
                ...state,
                allTemplates: action.payload,
                isLoading: false
            };
            
        case types.LOAD_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: action.payload,
                isLoading: false
            };
            
        default:
            return state;
    }
};

export default templateLibraryReducer;

// Selectors (Filtreleme mantığı)
export const getFilteredTemplates = (state) => {
    const { allTemplates, selectedCategoryId, searchQuery } = state.templateLibrary;
    
    let filtered = allTemplates;
    
    // Kategori filtresi
    if (selectedCategoryId && selectedCategoryId !== 'all') {
        filtered = filtered.filter(t => t.category === selectedCategoryId);
    }
    
    // Arama filtresi
    if (searchQuery && searchQuery.trim()) {
        const query = searchQuery.toLowerCase();
        filtered = filtered.filter(t => 
            t.name.toLowerCase().includes(query) ||
            t.description.toLowerCase().includes(query) ||
            (t.tags && t.tags.some(tag => tag.toLowerCase().includes(query)))
        );
    }
    
    return filtered;
};
